import api from "../../config/http-common";
import NDA from "../../Pages/NDA/NDA";

const getNDADocuments = (companyId) => {
  return api.unsecuredAxios().get("/web/nda/" + companyId);
};

const saveDocuments = (payload) => {
  return api.unsecuredAxios().post("/web/visit/ndadocuments", payload);
};

const NDAService = {
  getNDADocuments,
  saveDocuments,
};

export default NDAService;
